import {UseMutationResult, useMutation} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

interface GetActivePuzzlePayload {
  meetingId: string;
  occurenceId: string;
}

export default function useGetActivePuzzleApi(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (error: unknown) => void,
): UseMutationResult<any, unknown, GetActivePuzzlePayload> {
  return useMutation<any, unknown, GetActivePuzzlePayload>(
    async (payload: GetActivePuzzlePayload) => {
      const response = await ChessRestClient.post(
        'classroom/v1/get_active_puzzle/',
        payload,
      );
      console.log('Retrieved get_active_puzzle = ', response.data);
      return response.data;
    },
    {
      onSuccess: (data: any) => {
        if (handleOnSuccess) {
          handleOnSuccess(data);
        }
      },
      onError: (error: unknown) => {
        console.error('Failed to fetch get_active_puzzle data:', error);
        if (handleOnError) {
          handleOnError(error);
        }
      },
    },
  );
}
